import styled from "@emotion/styled";
import { spacing, surface, borderRadius, duration } from "@atlas-int/tokens";

export const SettingsButtonContainer = styled.button`
  text-transform: uppercase;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  border: none;
  background-color: transparent;
  border-radius: ${borderRadius.base};
  padding: ${spacing[2]} ${spacing[4]};
  transition: background-color ${duration.fast};

  &:hover {
    background-color: ${surface.hover};
  }

  & img {
    width: ${spacing[10]};
    margin-right: ${spacing[2]};
  }
`;
